//
//
//
//
//
//
//

import { getMediaType } from '@/helpers/mediaType.js';

const CATEGORY_MEDIA_TYPES = [
  'after-effects',
  'animation',
  'video',
  'music',
  '3d',
  'sound-effects',
  'premiere-pro',
  'image',
  'apple-motion',
  'davinci-resolve',
  'lottie',
  'ui',
  'presentation',
  'graphic',
  'midjourney-prompts',
  'prompt',
];

export default {
  name: 'media-type-id-index',
  components: {
    CategoryPageLoader: () => import('@/components/category/CategoryPageLoader.vue'),
    DlpLoader: () => import('@/components/dlp/DlpLoader.vue'),
  },
  async asyncData({ params, redirect }) {
    const mediaType = params.mediaType;
    const splitId = params.id.split('-');

    if (CATEGORY_MEDIA_TYPES.includes(mediaType)) {
      const id = splitId.pop();
      const isDlp = id.charAt(0) === 'd';
      return {
        mediaType,
        id,
        isDlp,
      };
    }

    if (getMediaType(mediaType)) {
      return redirect('/');
    }

    return redirect('/');
  },
};
